import { FC } from 'react'
import { SelectChangeEvent } from '@mui/material'

import { Select } from '@/components'
import { B2CTypePayment, OptionsValue } from '@/types.ts'

const MENU_ITEMS: OptionsValue<B2CTypePayment> = [
  { value: 'ALL', label: 'Все' },
  { value: 'ONE_TIME', label: 'Разовые' },
  { value: 'FROM_REGISTRY', label: 'Из реестра' },
]

type B2CPaymentsTypeSelectProps = {
  value: B2CTypePayment
  onChange: (event: SelectChangeEvent) => void
}

export const B2CPaymentsTypeSelect: FC<B2CPaymentsTypeSelectProps> = ({ value, onChange }) => {
  return <Select value={value} onChange={onChange} items={MENU_ITEMS} label="Переводы" labelId="b2c-payment-type" />
}
